import React from 'react';
import Base from './base.js';

export default () => {
  return <Base {...{ Scanner: null }} />;
};
